class FontChanger {
    constructor(config) {
        this.app = config.app;
        //this.fonts = config.fonts;

        this.customSelect = config.customSelect;
        this.trigger = this.customSelect.querySelector('.select-trigger');
        this.optionsContainer = this.customSelect.querySelector('.options');
        this.options = Array.from(this.customSelect.querySelectorAll('.option'));
        this.selectedText = this.customSelect.querySelector('.selected-text');

        this.isOpen = false;
        this.highlightedIndex = -1;
        
        this.init();
    }


    init() {
        this.customSelect.addEventListener("change", (event) => {
            this.selectFont(event.target.value);
        });


        // Mouse: Click trigger to toggle
        this.trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            this.isOpen ? this.closeDropdown() : this.openDropdown();
        });

        // Mouse: Click on any option
        this.options.forEach(option => {
            option.addEventListener('click', (e) => {
                e.stopPropagation(); // Prevent document click from closing immediately
                this.selectOption(option);
            });

            option.addEventListener('mouseover', (e) => {
                e.stopPropagation(); // Prevent document click from closing immediately
                this.highlightOption(parseInt(option.getAttribute("data-value"))-1);
            });
        });


        // Keyboard: Trigger keys
        /*
        this.trigger.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.openDropdown();
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                this.openDropdown();
                this.highlightedIndex = this.options.length - 1;
                this.highlightOption(this.highlightedIndex);
                this.options[this.highlightedIndex].scrollIntoView({ block: 'nearest' });
            } else if (e.key === 'Escape') {
                this.closeDropdown();
            }
        });
        */


        // Keyboard: Navigation when open (listen on document to catch arrows reliably)
        document.addEventListener('keydown', (e) => {
            if (!this.isOpen) 
                return;

            switch (e.key) {
                case 'ArrowDown':
                    e.preventDefault();
                    let next = (this.highlightedIndex + 1) % this.options.length;
                    console.log("next", next);
                    this.highlightOption(next);
                    this.options[next].scrollIntoView({ block: 'nearest' });
                    break;

                case 'ArrowUp':
                    e.preventDefault();
                    let prev = this.highlightedIndex - 1;
                    if (prev < 0) prev = this.options.length - 1;
                    console.log("prev", prev);
                    this.highlightOption(prev);
                    this.options[prev].scrollIntoView({ block: 'nearest' });
                    break;

                case 'Home':
                    e.preventDefault();
                    this.highlightOption(0);
                    this.options[0].scrollIntoView({ block: 'nearest' });
                    break;

                case 'End':
                    e.preventDefault();
                    this.highlightOption(this.options.length - 1);
                    this.options[this.options.length - 1].scrollIntoView({ block: 'nearest' });
                    break;

                case 'Enter':
                case ' ':
                    e.preventDefault();
                    if (this.highlightedIndex >= 0) {
                        this.selectOption(this.options[this.highlightedIndex]);
                    }
                    break;

                case 'Escape':
                    e.preventDefault();
                    this.closeDropdown();
                    this.trigger.focus();
                    break;
            }
        });


        // Close when clicking outside
        document.addEventListener('click', (e) => {
            if (!this.customSelect.contains(e.target)) {
                this.closeDropdown();
            }
        });


        // Visual focus indicator
        this.trigger.addEventListener('focus', () => this.trigger.classList.add('focused'));
        this.trigger.addEventListener('blur', () => this.trigger.classList.remove('focused'));


        // Optional: Type-to-search
        let typingBuffer = '';
        let typingTimeout;
        document.addEventListener('keydown', (e) => {
            if (!this.isOpen || e.ctrlKey || e.metaKey || e.altKey || ['Enter', ' ', 'Escape', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(e.key)) 
                return;

            if (e.key.length === 1 && e.key.match(/[a-z0-9]/i)) {
                typingBuffer += e.key.toLowerCase();
                clearTimeout(typingTimeout);
                typingTimeout = setTimeout(() => typingBuffer = '', 800);

                const matchIndex = this.options.findIndex(opt =>
                    opt.textContent.trim().toLowerCase().startsWith(typingBuffer)
                );
                if (matchIndex !== -1) {
                    this.highlightOption(matchIndex);
                    this.options[matchIndex].scrollIntoView({ block: 'nearest' });
                }
            }
        });
    }


    selectFont(font) {
        if (this.app.getSelectedNode()) {
            this.app.getSelectedNode().fontFamily(font);
        }
    }


    openDropdown() {
        if (this.isOpen) 
            return;

        this.optionsContainer.classList.add('open');
        this.customSelect.setAttribute('aria-expanded', 'true');
        this.isOpen = true;

        // Set initial highlight
        const selectedOpt = this.   options.find(opt => opt.classList.contains('selected'));
        this.highlightedIndex = selectedOpt ? this.options.indexOf(selectedOpt) : 0;
        this.highlightOption(this.highlightedIndex);
        this.options[this.highlightedIndex]?.scrollIntoView({ block: 'nearest' });
    }


    closeDropdown() {
        if (!this.isOpen) 
            return;

        this.optionsContainer.classList.remove('open');
        this.customSelect.setAttribute('aria-expanded', 'false');
        this.isOpen = false;
        this.removeHighlight();
    }


    highlightOption(index) {
        this.removeHighlight();

        if (index >= 0 && index < this.options.length) {
            let font = this.options[index].getAttribute("data-font");
            //console.log("highlightOption select font", font.replace(/\+/g, ' '));
            this.selectFont(font.replace(/\+/g, ' '));
            //this.selectFont(font);
            //document.getElementById("text").style.setProperty('font-family', font);

            this.options[index].classList.add('highlighted');
            this.highlightedIndex = index;
        }
    }


    removeValueFromArray(arr, val) {
        const index = arr.indexOf(val);

        if (index > -1) {
            arr.splice(index, 1);
        }
        
        return arr;
    }


    removeHighlight() {
        this.options.forEach(opt => opt.classList.remove('highlighted'));
    }

    
    selectOptionByFont(font) {
        this.options.forEach(opt => {
            if (opt.getAttribute("data-font").replace(/\+/g, ' ') == font) {
                this.selectOption(opt);
            }
        });
    }


    selectOption(option) {
        let font = option.getAttribute("data-font");
        //console.log("selectOption select font", font.replace(/\+/g, ' '));
        this.selectFont(font.replace(/\+/g, ' '));
        
        const index = this.options.indexOf(option);
        this.selectedText.textContent = option.textContent.trim();
        this.options.forEach(opt => {
            opt.classList.remove('selected');
            opt.setAttribute('aria-selected', 'false');
        });
        option.classList.add('selected');
        option.setAttribute('aria-selected', 'true');
        this.highlightedIndex = index;
        this.closeDropdown();
        this.trigger.focus();
    }

}
